import jwt from 'jsonwebtoken';
import { v4 } from 'uuid';

const userIdStorageKey = 'collegeProfileUserId';

/* istanbul ignore next:unexported function */
function getUserId() {
  let sub;
  try {
    sub = window.sessionStorage.getItem(userIdStorageKey);
    if (!sub) {
      sub = v4();
      window.sessionStorage.setItem(userIdStorageKey, sub);
    }
  } catch (e) {
    console.log('Failed getting userId, using random');
    sub = v4();
  }
  return sub;
}

const userContext = {
  jti: 'a9523c0a-5001-49e8-832f-3ab98ad7dfc3',
  iss: 'https://iam.naviance.com',
  sub: getUserId(),
  iat: 1509469808,
  exp: 1509473408,
  given_name: 'Richard',
  family_name: 'Robinson',
  email: 'r.ross.robinson+blue3hs@gmail.com',
  'https://oauth.naviance.com/oauth/claims/title': 'Technical Product Manager',
  'https://oauth.naviance.com/oauth/claims/community.admin': true,
  'https://oauth.naviance.com/oauth/claims/community.member': true,
  'https://oauth.naviance.com/oauth/claims/school.id': '00055889-ea38-4422-ba86-1ca2adf352f3',
};
const session = {
  isValid: () => true,
  jwt: jwt.sign(userContext, 'secret', {
    audience: 'qa.purple',
    keyid: 'f50efd79082a410ab65c68541e851921',
  }),
  clear: () => null, // logout function
};

/* istanbul ignore next:unexported function */
function setupSentryUserContext(idToken) {
  if (window.Raven) {
    window.Raven.setUserContext({
      id: idToken.sub,
      email: idToken.email,
    });
  }
}

setupSentryUserContext(userContext);

export default session;
